import { FolderContent } from '@/api/generatedApi';
import { useBulkModal } from '@/hooks/useBulkModal';

export const useBulkDeleteModal = <T extends FolderContent>({
  selectedRows,
  onClose,
  onComplete,
}: {
  selectedRows: T[];
  onClose: () => void;
  onComplete?: () => void;
}) => {
  const modal = useBulkModal({ selectedRows, onClose });

  const handleComplete = () => {
    modal.close();
    onComplete?.();
  };

  return { ...modal, handleComplete };
};
